//const url='http://localhost:8089';
//const static_url='https://gsjypxc.gcvtc.edu.cn/appi';
//const url='http://49.233.92.240:9000';
//const url='https://gsjypxc.gcvtc.edu.cn/appi';

//const url='http://49.233.92.240:9000';


//const static_url='http://10.1.64.86/api';
//const url='http://10.1.64.86/api';

//const static_url='http://localhost:8099';
//const url='http://localhost:8099';

//const static_url='http://192.168.31.171:8099/api';
//const url='http://localhost:8099/api';


const url='https://jxjypt.luas.edu.cn/api';
const static_url='https://jxjypt.luas.edu.cn/api';


export default {
   url,
   static_url
}